export enum SizeEnum {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  CUSTOM = "custom",
}

export enum ColorEnum {
  DEFAULT = "default",
  PRIMARY = "primary",
  "PRIMARY-LIGHT" = "primary-light",
  SECONDARY = "secondary",
  "SECONDARY-LIGHT" = "secondary-light",
  GRADIENT = "gradient",
  "WHITE-PRIMARY" = "white-primary",
  "SEMI-PRIMARY" = "semi-primary",
  "TRANSPARENT-PRIMARY" = "transparent-primary",
  "SEMI-SECONDARY" = "semi-secondary",
  "WHITE-ADDITIONAL" = "white-additional",
  "WHITE-SECONDARY" = "white-secondary",
  "TRANSPARENT-SECONDARY" = "transparent-secondary",
  GRAY = "gray",
  "WHITE-GRAY" = "white-gray",
  ADDITIONAL = "additional",
  "ADDITIONAL-LIGHT" = "additional-light",
  CUSTOM = "custom",
  WHITE = "white",
  ERROR = "error",
}

export const sizeValidator = (v: string) => v.toUpperCase() in SizeEnum;
